<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Настройки системы"
    />

    <base-material-card
      color="indigo"
      icon="mdi-cog"
      inline
    >
      <template v-slot:after-heading>
        <div class="text-h3 font-weight-light">
          Настройки системы
        </div>
      </template>
      <v-expansion-panels>
        <v-expansion-panel
          v-for="(setting, index) in items"
          :key="'setting_' + index"
        >
          <v-expansion-panel-header disable-icon-rotate>
            {{ setting.name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                v-for="(item, index) in setting.data"
                :key="'item_' + index"
                cols="12"
              >
                <v-text-field
                  v-model="item.value"
                  :label="item.name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn
                  color="primary"
                  min-width="100"
                  @click="save(setting)"
                >
                  Сохранить
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      items: []
    }),
    mounted: function () {
      this.load()
    },
    methods: {
      save: function (data) {
        this.axios.post('/api/setting/save', data)
          .then(result => {
            if (!result.data.error) {
              this.load()
            }
          })
          .catch(e => {

          })
      },
      load: function () {
        this.axios.post('/api/setting/list', {})
          .then(result => {
            if (!result.data.error) {
              this.items = result.data.data
            }
          })
          .catch(e => {

          })
      },
    },
  }
</script>
